import script from "./SubmitImageBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmitImageBox.vue?vue&type=script&setup=true&lang=js"

import "./SubmitImageBox.vue?vue&type=style&index=0&id=ee38860a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee38860a"]])

export default __exports__